import type { SemOpenListModule } from '~/contracts/sem';

import { Wrapper, ItemWrapper, Label, ImageWrapper } from './GridLayout.styles';

type OwnProps = { items: SemOpenListModule['items'] };

function GridLayout({ items }: OwnProps) {
  return (
    <Wrapper>
      {items?.map(item => {
        return item.link ? (
          <a
            href={item.link}
            key={item.label}
            className="inline-block !w-full no-underline"
            data-analytics-id="Shop By Makes - Make Item"
            data-analytics-attributes={JSON.stringify({
              title: item.label,
              linkUrl: item.link
            })}
          >
            <ItemWrapper>
              <ImageWrapper>
                {item.logoSrc && (
                  <div className="flex h-32 w-32 items-center">
                    <img
                      src={item.logoSrc}
                      alt={item.label ?? 'Label'}
                      className="object-cover"
                    />
                  </div>
                )}
              </ImageWrapper>
              <Label>{item.label}</Label>
            </ItemWrapper>
          </a>
        ) : null;
      })}
    </Wrapper>
  );
}

export default GridLayout;
